<script setup lang="ts">
import type { Schemas } from '#shopware'

interface CartSummaryProps {
    cart: Schemas['Cart']
    showCheckoutButton?: boolean
    showCartButton?: boolean
}

withDefaults(defineProps<CartSummaryProps>(), {
    showCheckoutButton: true,
    showCartButton: true
})

const emit = defineEmits<{
    'close': []
    'cart': []
}>()

const { getFormattedPrice } = usePrice()

const handleClose = () => {
    emit('close')
}

const handleCart = () => {
    emit('cart')
}
</script>

<template>
    <div>
        <div class="bg-base-200">
            <!-- Subtotal -->
            <div class="flex justify-between text-base py-3 px-6 md:px-9 border-b border-border">
                <span>{{ $t('cart.subtotal') }}</span>
                <span class="font-medium">{{ getFormattedPrice(cart.price?.positionPrice) }}</span>
            </div>
            
            <!-- Shipping costs -->
            <div class="flex justify-between text-base py-3 px-6 md:px-9 border-b border-border">
                <span>{{ $t('cart.shippingEstimate') }}</span>
                <span class="font-medium">{{ getFormattedPrice(cart.deliveries?.[0]?.shippingCosts?.totalPrice) }}</span>
            </div>

            <!-- Total -->
            <div class="flex justify-between text-base py-3 px-6 md:px-9 border-b border-border">
                <span class="font-bold">{{ $t('cart.orderTotal') }} ({{ $t(cart.price?.taxStatus === 'gross' ? 'cart.price.inclTax' : 'cart.price.exclTax') }})</span>
                <span class="font-bold">{{ getFormattedPrice(cart.price?.totalPrice) }}</span>
            </div>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 px-6 md:px-9 py-4">
            <!-- Continue shopping button -->
            <div>
                <FoundationButton
                    color="secondary"
                    class="w-full py-3 justify-center"
                    @click="handleClose"
                >
                    {{ $t('cart.continueShopping') }}
                </FoundationButton>
            </div>

            <!-- Cart button -->
            <div>
                <FoundationLink
                    to="/cart"
                    class="w-full btn btn-primary"
                    @click="handleCart"
                >
                    {{ $t('cart.title') }}
                </FoundationLink>
            </div>
        </div>
    </div>
</template>
